module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"submitterName":"Submitted by","submissionDate":"Submitted at","instanceId":"Instance ID"}}}')
  delete Component.options._Ctor
}
